import { render, staticRenderFns } from "./Japan.vue?vue&type=template&id=736c7acd&"
import script from "./Japan.vue?vue&type=script&lang=js&"
export * from "./Japan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736c7acd')) {
      api.createRecord('736c7acd', component.options)
    } else {
      api.reload('736c7acd', component.options)
    }
    module.hot.accept("./Japan.vue?vue&type=template&id=736c7acd&", function () {
      api.rerender('736c7acd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Japan.vue"
export default component.exports